import { ApiResponse, HttpClient } from '@store/base';
import _ from 'lodash';
import querystring from 'query-string';
import {
  GetGoodsEvalAiSummaryRequest,
  GetGoodsEvalAiSummaryResponse,
  GetGoodsEvaluationDetailRequest,
  GetGoodsEvaluationDetailResponse,
  GetGoodsEvaluationListRequest,
  GetGoodsEvaluationListResponse,
  GetGoodsEvaluationOptionListRequest,
  GetGoodsEvaluationOptionListResponse,
  GetGoodsEvaluationPhotoDetailRequest,
  GetGoodsEvaluationPhotoDetailResponse,
  GetGoodsEvaluationStatRequest,
  GetGoodsEvaluationStatResponse,
  GetGoodsPhotoEvaluationListRequest,
  GetGoodsPhotoEvaluationListResponse,
  LikeGoodsEvaluationRequest,
  UnlikeGoodsEvaluationRequest,
} from '../../model';

export class GetGoodsEvaluationListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsEvaluationListRequest) {
    const { gdsNo, ...body } = req;

    return await this.httpClient.request<GetGoodsEvaluationListResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v2/goods/${gdsNo}/evaluations`,
      body,
    });
  }
}

export class GetGoodsPhotoEvaluationListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsPhotoEvaluationListRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsPhotoEvaluationListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/evaluations/photos?${query}`,
    });
  }
}

export class GetGoodsEvaluationOptionListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsEvaluationOptionListRequest) {
    return await this.httpClient.request<GetGoodsEvaluationOptionListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/evaluations/options`,
    });
  }
}

export class GetGoodsEvaluationDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsEvaluationDetailRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsEvalNo'));
    return await this.httpClient.request<GetGoodsEvaluationDetailResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/evaluation/${req.gdsEvalNo}/detail?${query}`,
    });
  }
}

export class GetGoodsEvaluationPhotoDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsEvaluationPhotoDetailRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsEvaluationPhotoDetailResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/evaluations/photo-details?${query}`,
      },
    );
  }
}

export class LikeGoodsEvaluationGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: LikeGoodsEvaluationRequest) {
    return await this.httpClient.request<ApiResponse<{}>>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/evaluation/${req.gdsEvalNo}/detail/like`,
    });
  }
}

export class UnlikeGoodsEvaluationGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: UnlikeGoodsEvaluationRequest) {
    return await this.httpClient.request<ApiResponse<{}>>({
      method: 'DELETE',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/evaluation/${req.gdsEvalNo}/detail/like`,
    });
  }
}

export class GetGoodsEvalAiSummaryGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsEvalAiSummaryRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsEvalAiSummaryResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/evaluations/ai-summary?${query}`,
    });
  }
}

export class GetGoodsEvaluationStatGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsEvaluationStatRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    return await this.httpClient.request<GetGoodsEvaluationStatResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/evaluations/stat?${query}`,
    });
  }
}
